import { authFetch } from "../../utils/authFetch";

const apiURL = require('./apiURL');
const fetch = authFetch;
// const apiURL = `http://localhost:3000`;

// types of action
const Types = {
  WEBINAR_SET: "WEBINAR_SET",
  WEBINAR_EVENTS_LOADED: "WEBINAR_EVENTS_LOADED",
};

const setWebinar = webinar => ({
  type: Types.WEBINAR_SET,
  webinar
});

const eventsLoaded = (payload) => ({
  type: Types.WEBINAR_EVENTS_LOADED,
  payload,
});

const getEventbriteEvents = () => {

  return (dispatch,getState) => {

    fetch(apiURL + `/settings/eventbrite/events` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
    })
    .then(response => response.json())
    .then(data => {

        data.map(d => {
            // find if there is a country in square brackets
            const country = d.title.match(/\[(.*?)\]/);
            d.title = d.title.replace(/\[(.*?)\]/, '');
            d.country = country ? country[1].toLowerCase() : null;
        })

      dispatch(eventsLoaded(data))
    })

  }
};

const getEventDescription = (id) => {
  return (dispatch,getState) => {

    const state = getState();

    fetch(apiURL + `/settings/eventbrite/event/${id}` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(setWebinar({ ...state.webinars.list.find(w => w.webinarID == id), ...data }))
    })

  }
}

const Actions = {
  setWebinar,
  getEventbriteEvents,
  getEventDescription,
};


export {Types, Actions}